export const RELATIONSHIP = [
  'relationship.friend',
  'relationship.guardian',
  'relationship.parent',
  'relationship.partner',
  'relationship.sibling',
];
